import { TemplateTypes } from './email.template.item';
import { MemberDashboard } from '../ss-api/responses/member.dashboard.response';
import { TrainingEvent } from './training.event';
import { TrainingEmailEventTypes } from '../ss-api/requests/training.email.event.types';
import { TrainingEventSubscription } from './training.event.subscription';

export enum EmailWindowType {
    Member = 1,
    Training = 2
}

export class EmailWindowRequest {
    Type: EmailWindowType;
    Templates: Array<TemplateTypes>;
    MemberData?: MemberDashboard;
    TrainingEvent?: TrainingEvent;
    TrainingEventSubscription?: TrainingEventSubscription;
    TrainingEmailEventType?: TrainingEmailEventTypes;
}
